import React from 'react'
import { FECTH_UMBRACO_BRAND_PODIO_DATA } from '../../constantTypes/umbracobranddata/brandFormDataConstantTypes'

export const BrandFormPodioReducer=(state={},action)=> {
 
    switch (action.type) {
        case FECTH_UMBRACO_BRAND_PODIO_DATA:
            
            return {...state,brandpodioproductdata:action.payload}
    
        default:  return state;  
    }
}  


  